const tips = [
    {
        head: `Tips for Directive teams`,
        body: `This pairing will likely bite off more than they can chew, attempting too much at once; you should work to break things down methodically into achievable steps.`,
    },
    {
        head: `Tips for Communicative teams`,
        body: `The group may only see things above one 'level' and lack the attention to see the details below; a group more concerned
        with supporting and advising than the tangible results – might only listen when it’s convenient to them.`,
    },
    {
        head: `Tips for Stability teams`,
        body: `Consistent and reliable; however, if (and when) there is change to this groups' surroundings, this team will all take some time to adjust
        without anyone taking a real initiative. Try to each show your bravery, establish some
        priorities, don’t hold grudges, and don’t be so sensitive to criticism otherwise no one will speak
        up!`,
    },
    {
        head: `Tips for Productive teams`,
        body: `Don’t be afraid of criticism and all try to establish some clear-cut boundaries for actions and deliveries. Don’t get
        so bogged down in the details, K-I-S-S (Keep it simple stupid!). Sometimes ‘arguments’ are
        necessary to verbalize true feelings about a certain matter, don’t just give in rather than argue. Try
        to set a framework to talk things through effectively.`,
    },
    {
        head: `Tips for Productive teams S and I `,
        body: `A clash between energetic (I) and calm (S). I-types should listen attentively and be sure to ask S-types 
        questions about how they’re feeling about the matter at hand. S-types should openly communicate and work alongside I-types to find a reasonable compromise or solution.`,
    },
    {
        head: `Tips for Productive teams C and I `,
        body: `I-types should communicate their perspective in a clear and logical manner, avoiding excessive emotional language and tone. C-types need to be open-minded when hearing others' viewpoints and 
        straightforward when addressing their own point-of-view, remaining open to potential solutions to the situation.`,
    },
    {
        head: `Tips for Productive teams C and S`,
        body: `S-types need to come across to C’s clearly and logically, directly communicating their perspective and avoiding overuse of emotional language. C-types can help bring an objective angle to the emotionally-charged arrival to a S’s decision and should use a gentle tone when expressing their view.`,
    },
    {
        head: `Tips for Productive teams D and C`,
        body: `Both types will value honest and direct expression of disagreement. The two must tackle the conflict headfirst and find the quickkest and most efficient solution – D-types will need to take a step back and listen and address the questions of the C-type. Most likely, the C-type will need to compromise to the D-types, but make sure there is a reasonable compromise.`,
    },
    {
        head: `Tips for Productive teams D and I`,
        body: `Conflict is processed differently between this pair. D-types should utilize their humor to diffuse situations where their comments are taken too critically since D-types tend to naturally be a bit too blunt in the I-type's perspective. They should try and match each other by being direct and clear, while carefully listening to each's perspectives.`,
    },
    {
        head: `Tips for Productive teams D and S`,
        body: `S-types naturally float away from conflicts and D-types sees conflict as a means of improvement. There will be some conflicting patterns of thought so D-types should clearly ask S-type questions about their outlook on the matter. D-types should try a more calming tone and always manners first as to not get under the S-types skin.`,
    }

]

export {tips}
